"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgSpeedTest(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.5 22.49a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M25.625 16.866l-4.738 4.737", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M20 8.74c-7.594 0-13.75 6.157-13.75 13.75 0 7.595 6.156 13.75 13.75 13.75s13.75-6.155 13.75-13.75c0-7.593-6.156-13.75-13.75-13.75", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M20 3.115v5M22.5 2.49h-5M32.5 9.99l-2.652 2.652M35 11.24l-3.535-3.536", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
}
exports.default = SvgSpeedTest;
//# sourceMappingURL=SpeedTest.js.map